
import { Card, Row, Col, Form, Container } from 'react-bootstrap';
import * as React from 'react';
import PropTypes from 'prop-types';
import FamilyDetails from "../../Dashboard/familyDetails/page"
import "../../../App.css"
import { useEffect, useState } from 'react';
import { getGender, getReligion, getNationality, getCasteCategory, getMaritalData, getBloodGroup, getAllCategoryType } from '../../api/studentDetails';

function StudentDetails({ formData, setFormData, handleChange, errors }) {
    const [error, setError] = useState('');

    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [genderResponse, religionResponese, nationalityResponse, castecategoryResponse,
                    maritalResponse, bloodgroupResponse, categoryTypeResponse] = await Promise.all([
                        getGender(token),
                        getReligion(token),
                        getNationality(token),
                        getCasteCategory(token),
                        getMaritalData(token),
                        getBloodGroup(token),
                        getAllCategoryType(token),
                    ]);

                setFormData((prevData) => ({
                    ...prevData,
                    genderid: genderResponse.data,
                    religionid: religionResponese.data,
                    nationalityid: nationalityResponse.data,
                    casteid: castecategoryResponse.data,
                    maritalid: maritalResponse.data,
                    bloodgroupid: bloodgroupResponse.data,
                    categorytypeid: categoryTypeResponse.data
                }));
            } catch (error) {
                setError("Error fetching data:", error);
            }
        };
        fetchInitialData();
    }, [token]);
    return (
        <>
            <Container fluid>
                <Row className='mt-4'>
                    <Col >
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col>
                                        <Form>
                                            <Form.Label style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }} className='mb-3'>Personal Details</Form.Label>
                                            <Row>
                                                <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>First Name</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter First Name"
                                                                id="firstName"
                                                                name='firstName'
                                                                required value={formData.firstName}
                                                                onChange={(e) => handleChange('', 'firstName', e.target.value)} />
                                                            {errors.firstName && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.firstName}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>

                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Middle Name Unicode</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Middle Name Unicode"
                                                                id='middleNameunicode'
                                                                name='middleNameunicode'
                                                                required value={formData.middleNameunicode}
                                                                onChange={(e) => handleChange('', 'middleNameunicode', e.target.value)} />
                                                            {errors.middleNameunicode && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.middleNameunicode}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>

                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>ABC Id<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="text" placeholder="Enter ABC Id"
                                                                id='abcid'
                                                                name='abcid'
                                                                required value={formData.abcid}
                                                                onChange={(e) => handleChange('', 'abcid', e.target.value)} />
                                                            {errors.abcid && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.abcid}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>

                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2" >
                                                            <Form.Label>Nationality<span className="text-danger">*</span></Form.Label>
                                                            <Form.Select type="text"
                                                                id="selectedNationality"
                                                                required
                                                                name='selectedNationality'
                                                                value={formData.selectedNationality}
                                                                onChange={(e) => handleChange('', 'selectedNationality', e.target.value)}
                                                            >
                                                                <option value="">Select Nationality</option>
                                                                {formData.nationalityid.map((nation) => (
                                                                    <option key={nation.id} value={nation.id}>
                                                                        {nation.nationality}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            {errors.selectedNationality && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.selectedNationality}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>

                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Birth Place</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Birth Place"
                                                                id='birthPlace'
                                                                name='birthPlace'
                                                                required value={formData.birthPlace}
                                                                onChange={(e) => handleChange('', 'birthPlace', e.target.value)} />
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>UDISE No.</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter UDISE No."
                                                                id='udiseno'
                                                                name='udiseno'
                                                                required value={formData.udiseno}
                                                                onChange={(e) => handleChange('', 'udiseno', e.target.value)} />
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-2">
                                                        <Form.Group className="mb-2">
                                                            <Form.Label className="me-3" style={{ marginBottom: 15 }}>Differently Abled Student<span className="text-danger">*</span></Form.Label>
                                                            <div>
                                                                <Form.Check
                                                                    inline
                                                                    label="Yes"
                                                                    name="differentlyAbledStudent"
                                                                    type="radio"
                                                                    id="inline-radio-1"
                                                                    value={true}
                                                                    checked={formData.differentlyAbledStudent === true}
                                                                    onChange={(e) => handleChange('', 'differentlyAbledStudent', true)}
                                                                />
                                                                <Form.Check
                                                                    inline
                                                                    label="No"
                                                                    name="differentlyAbledStudent"
                                                                    type="radio"
                                                                    id="inline-radio-2"
                                                                    value={false}
                                                                    checked={formData.differentlyAbledStudent === false}
                                                                    onChange={(e) => handleChange('', 'differentlyAbledStudent', false)}
                                                                />
                                                            </div>
                                                        </Form.Group>
                                                    </Row>
                                                </Col>
                                                <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Middle Name </Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Middle Name"
                                                                id='middleName'
                                                                name='middleName'
                                                                required value={formData.middleName}
                                                                onChange={(e) => handleChange('', 'middleName', e.target.value)} />
                                                            {errors.middleName && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.middleName}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Last Name Unicode<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Last Name Unicode"
                                                                id='lastNameunicode'
                                                                name='lastNameunicode'
                                                                required value={formData.lastNameunicode}
                                                                onChange={(e) => handleChange('', 'lastNameunicode', e.target.value)} />
                                                        </Form.Group>
                                                        {errors.lastNameunicode && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                {errors.lastNameunicode}
                                                            </div>
                                                        )}
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Mobile No.<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Mobile No."
                                                                id='mobile'
                                                                name='mobile'
                                                                required value={formData.mobile}
                                                                onChange={(e) => handleChange('', 'mobile', e.target.value)} />
                                                            {errors.mobile && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.mobile}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Religion<span className="text-danger">*</span></Form.Label>
                                                            <Form.Select type="text"
                                                                id="selectedReligion"
                                                                required
                                                                name='selectedReligion'
                                                                value={formData.selectedReligion}
                                                                onChange={(e) => handleChange('', 'selectedReligion', e.target.value)}
                                                            >
                                                                <option>Select Religion</option>
                                                                {formData.religionid?.map((religion) => (
                                                                    <option key={religion.id} value={religion.id}>
                                                                        {religion.religion}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            {errors.selectedReligion && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.selectedReligion}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Marital Status<span className="text-danger">*</span></Form.Label>
                                                            <Form.Select type="text" placeholder="Please Enter Marital Status"
                                                                id="selectedMaritalstatus"
                                                                required
                                                                name='selectedMaritalstatus'
                                                                value={formData.selectedMaritalstatus}
                                                                onChange={(e) => handleChange('', 'selectedMaritalstatus', e.target.value)}
                                                            >
                                                                <option value="">Select Marital Status</option>
                                                                {formData.maritalid.map((marital) => (
                                                                    <option key={marital.id} value={marital.id}>
                                                                        {marital.maritalStatus}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            {errors.selectedMaritalstatus && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.selectedMaritalstatus}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Form.Group className="mb-2 ">
                                                            <Form.Label className="me-3" style={{ marginBottom: 15 }}>Social Reservation<span className="text-danger">*</span></Form.Label>
                                                            <div>
                                                                <Form.Check
                                                                    inline
                                                                    label="Yes"
                                                                    name="socialReservation"
                                                                    type="radio"
                                                                    id="inline-radio-1"
                                                                    value={true}
                                                                    checked={formData.socialReservation === true}
                                                                    onChange={(e) => handleChange('', 'socialReservation', true)}
                                                                />
                                                                <Form.Check
                                                                    inline
                                                                    label="No"
                                                                    name="socialReservation"
                                                                    type="radio"
                                                                    id="inline-radio-1"
                                                                    value={false}
                                                                    checked={formData.socialReservation === false}
                                                                    onChange={(e) => handleChange('', 'socialReservation', false)}
                                                                />
                                                            </div>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-2">
                                                        <Form.Group className="mb-2">
                                                            <Form.Label className="me-3" style={{ marginBottom: 15 }}>Are you Orphan Student<span className="text-danger">*</span></Form.Label>
                                                            <div>
                                                                <Form.Check
                                                                    inline
                                                                    label="Yes"
                                                                    name="areYouOrphanStudent"
                                                                    type="radio"
                                                                    id="inline-radio-1"
                                                                    value={true}
                                                                    checked={formData.areYouOrphanStudent === true}
                                                                    onChange={(e) => handleChange('', 'areYouOrphanStudent', true)}
                                                                />

                                                                <Form.Check
                                                                    inline
                                                                    label="No"
                                                                    name="areYouOrphanStudent"
                                                                    type="radio"
                                                                    id="inline-radio-2"
                                                                    value={false}
                                                                    checked={formData.areYouOrphanStudent === false}
                                                                    onChange={(e) => handleChange('', 'areYouOrphanStudent', false)}
                                                                />
                                                            </div>
                                                        </Form.Group>
                                                    </Row>
                                                </Col>

                                                <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Last Name<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Last Name"
                                                                id='lastName'
                                                                name='lastName'
                                                                required value={formData.lastName}
                                                                onChange={(e) => handleChange('', 'lastName', e.target.value)} />
                                                            {errors.lastName && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.lastName}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Name As Per Aadhar<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Name As Per Aadhar"
                                                                id='nameAsPerAdhar'
                                                                name='nameAsPerAdhar'
                                                                required value={formData.nameAsPerAdhar}
                                                                onChange={(e) => handleChange('', 'nameAsPerAdhar', e.target.value)} />
                                                            {errors.nameAsPerAdhar && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.nameAsPerAdhar}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Email<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="email" placeholder="Enter Email"
                                                                id='email'
                                                                name='email'
                                                                required value={formData.email}
                                                                onChange={(e) => handleChange('', 'email', e.target.value)} />
                                                            {errors.email && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.email}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Caste Category<span className="text-danger">*</span></Form.Label>
                                                            <Form.Select type="text"
                                                                id="selectedCasteCategory"
                                                                required
                                                                name='selectedCasteCategory'
                                                                value={formData.selectedCasteCategory}
                                                                onChange={(e) => handleChange('', 'selectedCasteCategory', e.target.value)}
                                                            >
                                                                <option value="">Select Caste Category</option>
                                                                {formData.casteid.map((caste) => (
                                                                    <option key={caste.id} value={caste.id}>
                                                                        {caste.casteCategory}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            {errors.selectedCasteCategory && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.selectedCasteCategory}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Blood Group<span className="text-danger">*</span></Form.Label>
                                                            <Form.Select type="text"
                                                                id="selectedBloodGroup"
                                                                required
                                                                name='selectedBloodGroup'
                                                                value={formData.selectedBloodGroup}
                                                                onChange={(e) => handleChange('', 'selectedBloodGroup', e.target.value)}
                                                            >
                                                                <option value="">SelectBlood Group</option>
                                                                {formData.bloodgroupid.map((bloodGroup) => (
                                                                    <option key={bloodGroup.id} value={bloodGroup.id}>
                                                                        {bloodGroup.bloodGroup}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            {errors.selectedBloodGroup && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.selectedBloodGroup}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-2">
                                                        <Form.Group className="mb-2 ">
                                                            <Form.Label className="me-3" style={{ marginBottom: 15 }}>Inhouse Student<span className="text-danger">*</span></Form.Label>
                                                            <div>
                                                                <Form.Check
                                                                    inline
                                                                    label="Yes"
                                                                    name="inhouseStudent"
                                                                    type="radio"
                                                                    id="inline-radio-1"
                                                                    value={true}
                                                                    checked={formData.inhouseStudent === true}
                                                                    onChange={(e) => handleChange('', 'inhouseStudent', true)}
                                                                />
                                                                <Form.Check
                                                                    inline
                                                                    label="No"
                                                                    name="inhouseStudent"
                                                                    type="radio"
                                                                    id="inline-radio-2"
                                                                    value={false}
                                                                    checked={formData.inhouseStudent === false}
                                                                    onChange={(e) => handleChange('', 'inhouseStudent', false)}
                                                                />
                                                            </div>
                                                        </Form.Group>
                                                    </Row>
                                                </Col>

                                                <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>First Name Unicode</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter First Name Unicode"
                                                                id='firstNameUnicode'
                                                                name='firstNameUnicode'
                                                                required value={formData.firstNameUnicode}
                                                                onChange={(e) => handleChange('', 'firstNameUnicode', e.target.value)} />
                                                            {errors.firstNameUnicode && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.firstNameUnicode}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Aadhar Card No.<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Aadhar Card No."
                                                                id='adharCard'
                                                                name='adharCard'
                                                                required value={formData.adharCard}
                                                                onChange={(e) => handleChange('', 'adharCard', e.target.value)} />
                                                            {errors.adharCard && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.adharCard}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>

                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Gender<span className="text-danger">*</span></Form.Label>
                                                            <Form.Select
                                                                id="selectedGender"
                                                                required
                                                                name='selectedGender'
                                                                value={formData.selectedGender}
                                                                onChange={(e) => handleChange('', 'selectedGender', e.target.value)}
                                                            >
                                                                <option value="">Select Gender</option>
                                                                {formData.genderid.map((gender) => (
                                                                    <option key={gender.id} value={gender.id}>
                                                                        {gender.genders}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            {errors.selectedGender && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.selectedGender}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>

                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Date Of Birth<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="date"
                                                                id='dateOfBirth'
                                                                name='dateOfBirth'
                                                                required value={formData.dateOfBirth}
                                                                onChange={(e) => handleChange('', 'dateOfBirth', e.target.value)} />
                                                            {errors.dateOfBirth && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.dateOfBirth}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Category Type</Form.Label>
                                                            <Form.Select type="text" placeholder="Enter Aadhar Card No."
                                                                id="selectedCategoryType"
                                                                required
                                                                name='selectedCategoryType'
                                                                value={formData.selectedCategoryType}
                                                                onChange={(e) => handleChange('', 'selectedCategoryType', e.target.value)}>
                                                                <option>Select Category Type</option>
                                                                {formData.categorytypeid.map((categoryType) => (
                                                                    <option key={categoryType.id} value={categoryType.id}>
                                                                        {categoryType.description}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-2">
                                                        <Form.Group className="mb-2">
                                                            <Form.Label className="me-3" style={{ marginBottom: 15 }}>Ex Servicemen Student<span className="text-danger">*</span></Form.Label>
                                                            <div>
                                                                <Form.Check
                                                                    inline
                                                                    label="Yes"
                                                                    name="exServicemen"
                                                                    type="radio"
                                                                    id="inline-radio-1"
                                                                    value={true}
                                                                    checked={formData.exServicemen === true}
                                                                    onChange={(e) => handleChange('', 'exServicemen', true)}
                                                                />
                                                                <Form.Check
                                                                    inline
                                                                    label="No"
                                                                    name="exServicemen"
                                                                    type="radio"
                                                                    id="inline-radio-2"
                                                                    value={false}
                                                                    checked={formData.exServicemen === false}
                                                                    onChange={(e) => handleChange('', 'exServicemen', false)}
                                                                />
                                                            </div>
                                                        </Form.Group>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <Card className='mt-2'>
                            <Card.Body>
                                <Form>
                                    <Form.Label style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }} className='mb-3'>Family Details</Form.Label>
                                    <Row>
                                        <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                            <Row className='mb-2'>
                                                <Form.Group className="mb-2" >
                                                    <Form.Label>Father Name (First & last only)<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Father Name"
                                                        id="fatherName"
                                                        name='fatherName'
                                                        required
                                                        value={formData?.fatherName}
                                                        onChange={(e) => handleChange('', 'fatherName', e.target.value)} />
                                                    {errors.fatherName && (
                                                        <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                            {errors.fatherName}
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </Row>

                                            <Row className='mb-2'>
                                                <Form.Group className="mb-2" >
                                                    <Form.Label>Total Family Members<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Total Family Members"
                                                        id="totalFamilyMember"
                                                        name='totalFamilyMember'
                                                        required value={formData?.totalFamilyMember}
                                                        onChange={(e) => handleChange('', 'totalFamilyMember', e.target.value)} />
                                                    {errors.totalFamilyMember && (
                                                        <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                            {errors.totalFamilyMember}
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </Row>
                                        </Col>
                                        <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                            <Row className='mb-2'>
                                                <Form.Group className="mb-2">
                                                    <Form.Label>Father Name Unicode (First & Last Only)<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Father Name Unicode"
                                                        id="fatherNameUnicode"
                                                        name='fatherNameUnicode'
                                                        required value={formData?.fatherNameUnicode}
                                                        onChange={(e) => handleChange('', 'fatherNameUnicode', e.target.value)} />
                                                    {errors.fatherNameUnicode && (
                                                        <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                            {errors.fatherNameUnicode}
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </Row>

                                            <Row className='mb-2'>
                                                <Form.Group className="mb-2" >
                                                    <Form.Label>Family Annual Income<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Family Annual Income"
                                                        id="familyAnnualIncome"
                                                        name='familyAnnualIncome'
                                                        required value={formData?.familyAnnualIncome}
                                                        onChange={(e) => handleChange('', 'familyAnnualIncome', e.target.value)} />
                                                    {errors.familyAnnualIncome && (
                                                        <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                            {errors.familyAnnualIncome}
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </Row>
                                        </Col>
                                        <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                            <Row className='mb-2'>
                                                <Form.Group className="mb-2">
                                                    <Form.Label>Mother Name (First Only)<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Mother Name"
                                                        id="MotherName"
                                                        name='MotherName'
                                                        required value={formData?.MotherName}
                                                        onChange={(e) => handleChange('', 'MotherName', e.target.value)} />
                                                    {errors.MotherName && (
                                                        <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                            {errors.MotherName}
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </Row>

                                            <Row className='mb-2'>
                                                <Form.Group className="mb-2">
                                                    <Form.Label>Parent Name (First & Last Only)</Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Parent Name"
                                                        id="ParentName"
                                                        name='ParentName'
                                                        required value={formData?.ParentName}
                                                        onChange={(e) => handleChange('', 'ParentName', e.target.value)} />
                                                    {errors.ParentName && (
                                                        <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                            {errors.ParentName}
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </Row>
                                        </Col>
                                        <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                            <Row className='mb-2'>
                                                <Form.Group className="mb-2">
                                                    <Form.Label>Mother Name Unicode (First Only)<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Mother Name Unicode"
                                                        id="motherNameUnicode"
                                                        name='motherNameUnicode'
                                                        required value={formData?.motherNameUnicode}
                                                        onChange={(e) => handleChange('', 'motherNameUnicode', e.target.value)} />
                                                    {errors.motherNameUnicode && (
                                                        <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                            {errors.motherNameUnicode}
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </Row>

                                            <Row className='mb-2'>
                                                <Form.Group className="mb-2">
                                                    <Form.Label>Parent Mobile No.</Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Parent Mobile NO."
                                                        id="parentMobile"
                                                        name='parentMobile'
                                                        required value={formData?.parentMobile}
                                                        onChange={(e) => handleChange('', 'parentMobile', e.target.value)} />
                                                    {errors.parentMobile && (
                                                        <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                            {errors.parentMobile}
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

        </>
    );
};

StudentDetails.propTypes = {
    formData: PropTypes.shape({
        firstName: PropTypes.string,
        middleNameunicode: PropTypes.string,
        abcid: PropTypes.string,
        selectedNationality: PropTypes.string,
        birthPlace: PropTypes.string,
        udiseno: PropTypes.string,
        middleName: PropTypes.string,
        lastNameunicode: PropTypes.string,
        mobile: PropTypes.string,
        selectedReligion: PropTypes.string,
        selectedMaritalstatus: PropTypes.string,
        lastName: PropTypes.string,
        nameAsPerAdhar: PropTypes.string,
        email: PropTypes.string,
        selectedCasteCategory: PropTypes.string,
        selectedBloodGroup: PropTypes.string,
        firstNameUnicode: PropTypes.string,
        adharCard: PropTypes.string,
        selectedGender: PropTypes.string,
        dateOfBirth: PropTypes.string,
        selectedCategoryType: PropTypes.string,
        exServicemen: PropTypes.bool,
        inhouseStudent: PropTypes.bool,
        areYouOrphanStudent: PropTypes.bool,
        socialReservation: PropTypes.bool,
        differentlyAbledStudent: PropTypes.bool
    }).isRequired,
    setFormData: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
};


export default StudentDetails;
